<template>
  <b-modal
    id="product-modal"
    ref="ground-product-modal-ref"
    hide-footer
    :title="title"
  >
    <div v-if="accordions.length">
      <div class="d-flex justify-content-end">
        <b-link
          @click="toggleAll"
          class="cursor"
        >
          <span class="d-inline-block text-left" style="width: 90px;">
            {{ expandAll ? 'Collapse All' : 'Expand All' }}
          </span>
          <span>
            <b-icon icon="arrows-expand" class="h5 mb-0" v-if="!expandAll"></b-icon>
            <b-icon icon="arrows-collapse" class="h5 mb-0" v-if="expandAll"></b-icon>

          </span>
          <div class="toggle-essential">
          </div>
        </b-link>
      </div>

      <div
        v-for="(item, index) of accordions"
        :key="index"
      >
        <b-button
          :id="'buttonID-' + index"
          class="accordion-btn"
          :class="{ 'item-active': item.expand }"
          size="sm"
          @click="toggleExpand(index)"
        >
          <div class="item-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="toggle-essential">
            <span v-if="!item.expand">+</span>
            <span v-else>-</span>
          </div>
        </b-button>

        <b-collapse
          :id="'product-supplier' + index"
          v-model="item.expand"
        >
          <div class="item-dropdown accordions">
            <div class="item-dropdown-main accordions-main">
              <div class="extra-info-essentials">
                <div>
                  <p v-html="item.content" />
                </div>
                <div
                  v-if="item.base64image"
                  class="extra-info-img"
                >
                  <img
                    class="non-gallery-img"
                    :src="item.base64image"
                    alt="accordion image"
                  >
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <ServiceErrorMessage
      :error-loading-data="errorLoadingData"
    />
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import ServiceErrorMessage from "@/partials/service-error-message";
import {mapGetters} from "vuex";
export default {
  components: { ServiceErrorMessage },
  data() {
    return {
      errorLoadingData: false,
      title: '',
      accordions: [],
      expandAll: false
    };
  },
  computed: {
    ...mapGetters({ sessionNum: "booking/getSessionID" }),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
  methods: {
    toggleExpand(index) {
      this.accordions[index].expand = !this.accordions[index].expand
      this.$forceUpdate()
    },
    toggleAll() {
      this.expandAll = !this.expandAll
      this.accordions.map(item => {
        item.expand = this.expandAll
        return item
      })
      this.$forceUpdate()
    },
    closeModal() {
      this.$refs["ground-product-modal-ref"].hide();
    },
    async showModal(essentialInfoData) {
      if (!essentialInfoData) {
        this.errorLoadingData = true
      }
      this.accordions = essentialInfoData.accordions
      // add a flag for accordions
      this.accordions = this.accordions.map(el => {
        el.expand = false
        return el
      })
      // expand if it's the only one
      if (this.accordions.length === 1) {
        this.accordions[0].expand = true
      }
      this.title = 'Essential Information'
      // product info
      if (essentialInfoData.infoType === 'product') {
        this.title = `Essential ${essentialInfoData.productType.charAt(0).toUpperCase() + essentialInfoData.productType.slice(1)} Information`
        if (essentialInfoData.productType === 'tour') {
          const tourType = essentialInfoData.tourType.toLowerCase()
          this.title = `Essential ${tourType.charAt(0).toUpperCase() + tourType.slice(1)} Information`
        }
      }
      if (essentialInfoData.infoType === 'destination') {
        this.title = 'Essential Destination Information'
      }
      if (essentialInfoData.infoType === 'checkin') {
        this.title = 'Action Required'
      }
      this.$refs["ground-product-modal-ref"].show();
    },
  },
};
</script>
<style lang="scss">
@import "./style.scss";
</style>

